import { type ReactElement } from 'react';

export const ArrowThinRight = ({ className }: { className?: string }): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5488 11.9993L8.00004 4.71451L8.71142 4.00049L17 11.9992L8.71146 19.9995L8 19.2855L15.5488 11.9993Z"
        fill="currentColor"
      />
    </svg>
  );
};
